const PALETTE = ['#3B4D7F', '#E59D02', '#57B792', '#EF4642'];

/** Цвет закреплён за человеком детерминированно. Id бывает числом (legacy) и
 *  UUID-строкой (v2) — строку сводим к числу суммой кодов. */
export function personColor(id: number | string) {
  const n =
    typeof id === 'number'
      ? id
      : [...String(id)].reduce((a, c) => a + c.charCodeAt(0), 0);
  return PALETTE[Math.abs(Math.trunc(n)) % PALETTE.length];
}

export function personInitials(name: string) {
  const parts = String(name ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}

/** Кружок сотрудника: фото, если есть, иначе инициалы на цвете по id. */
export function RPersonAvatar({
  id,
  name,
  avatarUrl,
  size = 24,
  fontSize = 9.5,
}: {
  id: number | string;
  name: string;
  avatarUrl?: string | null;
  size?: number;
  fontSize?: number;
}) {
  return (
    <span
      className="flex shrink-0 items-center justify-center overflow-hidden rounded-full font-bold text-white"
      style={{
        flex: `0 0 ${size}px`,
        width: size,
        height: size,
        background: personColor(id),
        fontSize,
      }}
      aria-hidden
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt=""
          className="h-full w-full object-cover"
          draggable={false}
        />
      ) : (
        personInitials(name)
      )}
    </span>
  );
}
